import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "app_theme";

function readInitialIsDark(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark";
  } catch {
    return false;
  }
}

export interface ThemeState {
  isDark: boolean;
}

const initialState: ThemeState = {
  isDark: readInitialIsDark(),
};

const themeSlice = createSlice({
  name: "themeSlice",
  initialState,
  reducers: {
    TOGGLE_THEME: (state) => {
      state.isDark = !state.isDark;
      try {
        localStorage.setItem(STORAGE_KEY, state.isDark ? "dark" : "light");
      } catch {
        // ignore
      }
    },
  },
});

export const { TOGGLE_THEME } = themeSlice.actions;
export default themeSlice.reducer;
